export default "__VITE_ASSET__a_i7ENJ6__"